<template>
	<div>
		<b-list-group>
			<b-list-group-item v-for="project in projects" v-bind:key="project.id" :to="'/project/'+project.id"><span class="badge badge-primary" v-if="statuses[project.status]">[{{statuses[project.status]}}]</span> {{project.title}} | {{ new Date(project.created) | moment("DD/MM/YYYY") }}</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
export default {
	name: 'ProjectListPage',
	data(){
		return {
			projects:[],
			statuses:{
				in_progress:"In Progress",
				in_review:"In Review",
				on_hold:"On Hold",
				done:"Finished",
				cancelled:"Cancelled"
			}
		}
	},
	mounted(){
		if(!this.$API.loggedIn){
			this.$router.push("/login?redirect=" + this.$route.path)
			return;
		}
		this.loadList(this.$route.params.type,this.$route.params.status);
	},
	methods:{
		loadList(type,status){
			if(["my","other"].indexOf(type)<0){
				this.$router.push("/404");
				return;
			}
			if(["offers","active","archive"].indexOf(status)<0){
				this.$router.push("/404");
				return;
			}
			this.$API.title=type.charAt(0).toUpperCase() + type.slice(1) + " " + status.charAt(0).toUpperCase() + status.slice(1);
			this.$API.apiGET(`/projects/list?type=${type}&status=${status}`, true).then((response)=>{
				this.projects=response.projects;
			});
		}
	}
}	
</script>